var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'data-loading': !_vm.catalogData }]},[(_vm.catalogData)?_c('WCatalog',{staticClass:"home-catalog",attrs:{"id":_vm.id,"catalog":_vm.catalogData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }